import * as React from "react";
const SvgVector335 = (props) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 12, viewBox: "0 0 13 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.04166 7.375L4.24999 10.5833L12.5 0.5", stroke: "#F1F3F3", strokeLinecap: "round" }));
export default SvgVector335;
